import { Province } from './province';

export class District {

    constructor(
        public id?: string,
        public code?: string,
        public name?: string,
        public province?: Province
    ) {}

}



// WEBPACK FOOTER //
// ./src/app/core/entities/district.ts